import {createSelector} from 'reselect';
import {AppState} from '../..';
import {CardStatus} from '../../../types/enums/cardStatus';

export const canReissueCardSelector = () =>
  createSelector(
    (state: AppState) => state.profile.holder,
    (state: AppState) => state.login.esiaUserHasNoCards,
    (holder, userHasNoCards) => {
      if (!holder) return false;

      const isBlocked = Boolean(holder.uscIsBlocked) || holder.cardStatusId === CardStatus.Blocked;

      return isBlocked && !userHasNoCards;
    },
  );
